<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Actualités" />
            <ActualitePoste />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ActualitePoste from '../ActualitePoste/ActualitePoste'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ActualitePostePage',
    components: {
        NavBar,
        PageTitle,
        ActualitePoste,
        FooterComp,
    }
}
</script>